import { useTranslations } from "../../i18n";
import { Pagination } from "../Pagination";
import { useTableContext } from "./context";
import { Selection } from "./Selection";

export function TableFooter() {
  const { t } = useTranslations();
  const { pagination, selection, ariaLabel } = useTableContext();

  const hasSelection =
    selection && (selection.selectAll || selection.selectedItems.length > 0);

  if (!pagination && !hasSelection) {
    return null;
  }

  // A named table names its pagination landmark too, so two tables don't share one name.
  const paginationLabel =
    pagination?.ariaLabel ??
    (ariaLabel
      ? t("ui.table.paginationAriaLabel", { table: ariaLabel })
      : undefined);

  return (
    <div className="nuco-table__footer">
      <Selection />
      {pagination && (
        <div className="nuco-table__footer-pagination">
          <Pagination {...pagination} ariaLabel={paginationLabel} />
        </div>
      )}
    </div>
  );
}
